import * as Sentry from '@sentry/browser'
import 'primereact/resources/primereact.min.css'
import 'primereact/resources/themes/nova/theme.css'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { AuthProvider } from './auth/AuthContext'
import { App } from './components/App'
import { AppFooterComponent } from './components/common/AppFooter/AppFooterComponent'
import { Environment } from './environment'
import './index.scss'
import { store } from './redux/store'
import React from 'react'
import i18next from 'i18next'
import { initTranslations } from './i18n/i18next'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

if (Environment.Current !== 'development' && !('enableLogs' in window)) {
  console.log = () => undefined
}

Sentry.init({
  dsn: 'https://1e2dd77902854525b602de042e702463@sentry.interfleet.ch/16',
  beforeSend(event) {
    if (!event.tags) {
      event.tags = {}
    }
    event.tags.url = location.toString()
    return event
  },
  environment: Environment.Current,
  enabled: Environment.Current !== 'development',
})

initTranslations().then(() => {
  root.render(
    <React.StrictMode>
      <I18nextProvider i18n={i18next}>
        <Router>
          <Provider store={store}>
            <AuthProvider>
              <App />
              <AppFooterComponent />
            </AuthProvider>
          </Provider>
        </Router>
      </I18nextProvider>
    </React.StrictMode>
  )
})
